import { useNuxtApp } from "#app";
import { BaseService } from "../base/base.service";
import type { IModelResponse } from "../base/dto/base.dto";
import { ModelGETKnowledgeDocument, type IModelGETKnowledgeDocumentRequest, type IModelGETKnowledgeDocumentResponse } from "./dto/knowledge-document.dto";

import { KnowledgeDocumentRepository } from "./knowledge-document.repository";


export class KnowledgeDocumentService extends BaseService {
  private knowledgeDocumentRepository = new KnowledgeDocumentRepository(this.api, this.configService);

  async getKnowledgeDocument(params: IModelGETKnowledgeDocumentRequest): Promise<IModelResponse<ModelGETKnowledgeDocument[]>> {
    const { $functions } = useNuxtApp();
    let dataResult: IModelResponse<ModelGETKnowledgeDocument[]> = {
      data: [],
    };

    try {
      const res = await this.knowledgeDocumentRepository.getKnowledgeDocument(params);
      const resData = res?.data?.value;
      if (resData && $functions.isValidResponse(resData)) {
        const dataList = (resData.data || []).map((e: IModelGETKnowledgeDocumentResponse) => new ModelGETKnowledgeDocument(e))
        dataResult.data = dataList;
        dataResult.totalItems = resData.totalItems || 0;
        console.log('getKnowledgeDocument', params, resData.data, dataResult);
      }
    } catch (err: any) {
      const errorMessage = err?.message || err?.response?._data?.message || 'An error occurred';
      $functions.notify.error({
        text: errorMessage
      });
      console.log(err, KnowledgeDocumentService.name);
    }

    return dataResult;
  }

  async getKnowledgeDocumentById(id: string): Promise<ModelGETKnowledgeDocument | null> {
    const { $functions } = useNuxtApp();
    let dataResult: ModelGETKnowledgeDocument | null = null;

    try {
      const res = await this.knowledgeDocumentRepository.getKnowledgeDocumentById(id);
      const resData = res?.data?.value;
      if (resData && $functions.isValidResponse(resData)) {
        dataResult = new ModelGETKnowledgeDocument(resData.data);
        console.log('getKnowledgeDocumentById', id, resData.data, dataResult);
      }
    } catch (err: any) {
      const errorMessage = err?.message || err?.response?._data?.message || 'An error occurred';
      $functions.notify.error({
        text: errorMessage
      });
      console.log(err, KnowledgeDocumentService.name);
    }

    return dataResult;
  }

  async deleteKnowledgeDocument(params: string): Promise<any> {
    const { $functions } = useNuxtApp();
    let dataResult;

    try {
      const res = await this.knowledgeDocumentRepository.deleteKnowledgeDocument(params);
      const resData = res?.data?.value;
      if (resData && $functions.isValidResponse(resData)) {
        dataResult = resData.data
        console.log('deleteKnowledgeDocument', params, resData.data, dataResult);
      }
    } catch (err: any) {
      const errorMessage = err?.message || err?.response?._data?.message || 'An error occurred';
      $functions.notify.error({
        text: errorMessage
      });
      console.log(err, KnowledgeDocumentService.name);
    }

    return dataResult;
  }
}

